import client from '../../client/funClient';
import funDetailClient from '../../client/funDetailClient';
import funDetailDataClient from '../../client/funDetailDataClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    public async save(params: any) {
        const result = await client.save(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async removeByIds(params: any) {
        const result = await client.removeByIds(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async updateById(params: any) {
        const result = await client.updateById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }
    
    public async getById(params: any) {
        const result = await client.getById(params);
        if (result) {
            return result;
        } else {
            return null;
        }
    }

    public async selectPageData(params: any) {
        const result = await client.selectPageData(params);
        if (result) {
            return result;
        }
    }
    
    // 查询功能详情，分页
    public async selectFunDetailPageData(params: any) {
        const result = await funDetailClient.selectPageData(params);
        return result;
    }

    // 根据功能id判断该功能下是否还有具体数据
    public async selectFunDetailDataCountByFunId(params: any) {
        const result = await funDetailDataClient.selectFunDetailDataCountByFunId(params);
        return result;
    }

    
    
}
